import { Component, OnInit, Input, ViewChild, OnChanges } from "@angular/core";
import { ApplicationStage, CustomerAppStatus, LinkingStatus } from "common";
import { ApplicationData } from "../../application/application.model";
import { BankingService } from "../../bank-account/banking.service";
import { Router } from "@angular/router";
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: "ifp-application-status-stepper",
    templateUrl: "./application-status-stepper.component.html",
    styleUrls: ["./application-status-stepper.component.scss"],
    standalone: false
})
export class ApplicationStatusStepperComponent implements OnInit, OnChanges {
  @ViewChild("verticalStepper", { static: true }) verticalStepper;

  @Input()
  application: ApplicationData;

  readonly ApplicationStage = ApplicationStage;

  message = "";
  showError: boolean;
  unlinkedBank: boolean;
  lastStep: boolean;
  showLinkBankButton: boolean;

  steps = ["Application created", "Underwriting", "Decision"];

  constructor(private router: Router, private bankingService: BankingService) {}

  ngOnInit() {
    this.bankingService.obsSync.pipe(untilDestroyed(this)).subscribe(() => {
      this.showLinkBankButton = false;
    });

    this.bankingService.obsInstitutionLinkStatus
      .pipe(untilDestroyed(this))
      .subscribe((res) => (this.showLinkBankButton = !res));
  }

  ngOnChanges(): void {
    this.initData();
  }

  private initData() {
    this.showError = false;
    this.unlinkedBank =
      this.application?.bankLinkStatus !== LinkingStatus.Linked;
    this.showLinkBankButton = this.unlinkedBank;
    switch (this.application?.customerFacingStatus) {
      case CustomerAppStatus.Processing:
        this.verticalStepper.selectedIndex = 0;
        this.message = this.unlinkedBank
          ? "Link your bank to continue with the application process. Schedule a call if you have any questions."
          : "Your application is up for review. Come back later to check on the status.";
        this.showError = this.unlinkedBank;
        break;
      case CustomerAppStatus.Underwriting:
        this.verticalStepper.selectedIndex = 1;
        if (this.application.stage === ApplicationStage.UnderwritingMissingInfo)
        {
          this.message = "We are missing some information. A business advisor will reach " +
            "out to you shortly. Schedule a call if you have any questions.";
          this.showError = true;
        }
        else
        {
          this.message = "Your application is currently under review.";
        }
        break;
      case CustomerAppStatus.Approved:
        this.verticalStepper.selectedIndex = 2;
        this.lastStep = true;
        this.message =
          "Congratulations! Your application has been approved. See your offer now.";
        break;
      case CustomerAppStatus.Closing:
        this.verticalStepper.selectedIndex = 2;
        this.lastStep = true;
        this.message =
          "Congratulations! Your application is now closing. A business advisor will reach out shortly.";
        break;
      case CustomerAppStatus.UnderwritingCall:
        this.verticalStepper.selectedIndex = 2;
        this.showError = true;
        this.lastStep = true;
        this.message =
          "We have a couple more questions regarding your application. Schedule a call to close your application.";
        break;
      case CustomerAppStatus.UnableToFund:
        this.message =
          "Unfortunately we are unable to accept your application at this moment. " + 
          "Please try again at a later time. Schedule a call if you have any questions.";
        break;
      case CustomerAppStatus.Dormant:
        this.verticalStepper.selectedIndex = 2;
        this.message =
          "Your application is now dormant. Schedule a call if you have any questions.";
        break;
    }
  }

  link() {
    this.router.navigate(["/bank-link-reminder"]);
  }

  offer() {
    this.router.navigate(
      [`/application/${this.application.id}/offers/summary`],
      {
        replaceUrl: true,
      }
    );
  }

  calendarLink() {
    window.open(
      this.application?.advisorCalendarLinkUrl ??
        "https://calendly.com/ideafinancial",
      "_blank"
    );
  }
}
